import Select, { MultiValue, SingleValue } from "react-select";
import styled, { css } from "styled-components";

interface SelectProps {
  color?: string;
}

const Wrapper = styled.div<SelectProps>`
  ${({ color }) =>
    color &&
    css`
      div[class$="-control"] {
        border-radius: 6px;
        border-color: ${color === "failure"
          ? "rgb(240 82 82 / var(--tw-border-opacity))"
          : "rgb(209 213 219 / var(--tw-border-opacity))"} !important;
        height: 42px;
        background-color: ${color === "failure"
          ? "rgb(253 242 242 / var(--tw-bg-opacity))"
          : "rgb(249 250 251 / var(--tw-bg-opacity))"};
      }
    `}
`;

interface MultiSelectProps {
  options: Array<{ value: string; label: string }>;
  onChange: (
    value:
      | SingleValue<{ value: string; label: string }>
      | MultiValue<{ value: string; label: string }>
  ) => void;
  isMulti?: boolean;
  helperText?: string;
  color?: string;
  id?: string;
  defaultValue?: any;
}

const MonSelect = (props: MultiSelectProps) => {
  return (
    <>
      <Wrapper color={props.color}>
        <Select
          isMulti={props.isMulti}
          options={props.options}
          onChange={props.onChange}
          id={props.id ?? ""}
          defaultValue={props.defaultValue}
        />
      </Wrapper>
      {props.helperText && (
        <p className="mt-2 text-sm text-red-600 dark:text-red-500">
          {props.helperText}
        </p>
      )}
    </>
  );
};

export default MonSelect;
